const DropdownTheme = {
  dropdown: "relative",
};

export default DropdownTheme;
